import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ERROR_CODES } from '../types/error';
import { ErrorFallBack } from '../views/Error';
import BrandGroupContainer from '../components/BrandGroupContainer';
import { ROUTES } from './types';
import AccountConsent from '../views/AccountConsent';
import RegistrationFlowView from '../views/RegistrationFlowView';
import BundlingUpgrade from '../views/BundlingUpgrade';
import SpotifyUpgrade from '../views/SpotifyUpgrade';
import SpotifyError from '../views/SpotifyError';
import Invitation from '../views/Invitation';
import InvitationError from '../views/InvitationError';

function RouterProvider() {
  return (
    <Routes>
      <Route
        path={ROUTES.COMPLETE_REGISTRATION}
        element={
          <BrandGroupContainer>
            <RegistrationFlowView />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.ACCOUNT_CONSENT}
        element={
          <BrandGroupContainer>
            <AccountConsent />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.BUNDLING_UPGRADE}
        element={
          <BrandGroupContainer>
            <BundlingUpgrade />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.SPOTIFY_UPGRADE}
        element={
          <BrandGroupContainer>
            <SpotifyUpgrade />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.SPOTIFY_ERROR}
        element={
          <BrandGroupContainer>
            <SpotifyError />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.INVITATION_ACCEPT}
        element={
          <BrandGroupContainer>
            <Invitation />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.INVITATION_ERROR}
        element={
          <BrandGroupContainer>
            <InvitationError />
          </BrandGroupContainer>
        }></Route>
      <Route
        path={ROUTES.INTERNAL_ERROR}
        element={<ErrorFallBack error={Error(ERROR_CODES.INTERNAL_ERROR.toString())} />}></Route>
      <Route
        path="*"
        element={<ErrorFallBack error={Error(ERROR_CODES.NOT_FOUND.toString())} />}></Route>
    </Routes>
  );
}

export default RouterProvider;
